
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import { Contact } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { ProspectService } from "@/services/prospect-service";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { View } from "@/models/view";

export default Vue.extend({
	computed: {
		dataSource():IBrowseBaseDataSource<Contact> {
			return {
				getSettings: () => BrowseService.getBrowse(3),
				getElements: ProspectService.getContacts.bind(ProspectService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return ProspectService.getTotals(view);
				},
				browseName: "Prospects",
				modelName: "Contact"
			};
		}
	},
	methods: {
		onClick(contact:Contact) {
			this.$emit("click", contact);
		}
	},
	components: {
		AppSearchBrowse
	}
});
